import { RoleName, User } from "@/modules/users/types";

export { hasRole };

const hasRole = (roles: RoleName[], user: User | null | undefined) =>
  roles.includes(user?.role?.name || ("" as RoleName));
